import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import xClose from "../../../assets/x-close.svg";
import ButtonLoader from "./ButtonLoader"; 
import { getPrivacyPolicy } from "../../../store/actions/header";

const Privacy = ({ onClose }: any) => {
  const dispatch: any = useDispatch();
  const { t } = useTranslation();

  const [privacyPolicyData, setPrivacyPolicyData] = useState<any>(null);

  const { loading } = useSelector((state: any) => state.auth);

  const privacyPolicy = async () => {
    try {
      const response = await getPrivacyPolicy(dispatch);
      setPrivacyPolicyData(response);
    } catch (error: any) {
      console.error(error);
      toast.error(error);
    }
  };

  useEffect(() => {
    privacyPolicy();
    window.scrollTo(0,0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="flex flex-col bg-white rounded-lg p-5 w-[84%] m-auto">
      <div className="">
        <div className="flex justify-between mt-16">
          <h4 className="font-medium text-2xl">{t("footer_3")}</h4>
          {
            onClose &&
            <img
            src={xClose}
            alt="close"
            className="cursor-pointer"
            onClick={onClose}
          />
          }
        </div>
      </div>
      {loading ? (
        <div className="h-[80vh] flex justify-center items-center">
          <ButtonLoader />
        </div>
      ) : (
        <div
          className="h-[80vh] overflow-y-auto"
          dangerouslySetInnerHTML={{ __html: privacyPolicyData }}
        ></div>
      )}
    </div>
  );
};

export default Privacy;
